import { render, staticRenderFns } from "./agb.vue?vue&type=template&id=5ce50f22&scoped=true&"
import script from "./agb.vue?vue&type=script&lang=js&"
export * from "./agb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce50f22",
  null
  
)

export default component.exports